<template>
  <el-drawer v-model="DrawerVisible" :destroy-on-close="true" class="DrawerStyle">
    <template #header>
      <h4>{{ title }}</h4>
    </template>
    <template #default>
      <!-- 内容 -->
      <div class="content">
        <el-form :model="ruleForm" ref="ruleFormRef" :rules="rules">

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="参数名称：" :label-width="formLabelWidth" prop="configName">
                <el-input v-model="ruleForm.configName" autocomplete="off"  />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="参数键名：" :label-width="formLabelWidth" prop="configKey">
                <el-input v-model="ruleForm.configKey" autocomplete="off"  />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="参数键值：" :label-width="formLabelWidth" prop="configValue">
                <el-input v-model="ruleForm.configValue" autocomplete="off"  />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="系统内置：" :label-width="formLabelWidth" prop="configType">
                <el-radio-group v-model="ruleForm.configType" class="ml-4">
                  <el-radio label="Y" size="large">是</el-radio>
                  <el-radio label="N" size="large">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="备注：" :label-width="formLabelWidth" prop="remark">
                <el-input type="textarea" :maxlength="150" show-word-limit :rows="3" v-model="ruleForm.remark"
                  autocomplete="off"  />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </template>
    <template #footer>
      <div>
        <el-button color="#417FF9" @click="confirmClick(ruleFormRef)">提交</el-button>
        <el-button class="restBtn" @click="resetForm(ruleFormRef)">取消</el-button>
      </div>
    </template>
  </el-drawer>
</template>

<script setup lang="ts">
import { FormInstance, FormRules } from 'element-plus';

const props = defineProps({
  ruleForm: {
    type: Object, default: {
      configName: '',
      configKey: '',
      configValue: '',
      configType: '',
      remark: '',
    }
  },
  title: String
})

const formLabelWidth = '100px'
const ruleFormRef = ref<FormInstance>()
const DrawerVisible = ref(false)
const rules = reactive<FormRules>({
  configName: [
    {
      required: true,
      message: '请填写参数名称',
      trigger: 'blur',
    },
  ],
  configKey: [
    {
      required: true,
      message: '请填写参数Key',
      trigger: 'blur',
    },
  ],
  configValue: [
    {
      required: true,
      message: '请填写参数Value',
      trigger: 'blur',
    },
  ],
  configType: [
    {
      required: true,
      message: '请选择系统内置',
      trigger: 'change',
    },
  ],
  remark: [
    {
      required: true,
      message: '请填写角色描述备注',
      trigger: 'blur',
    },
  ],
})

const emit = defineEmits(["SetFormData"])

const confirmClick = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {

      emit('SetFormData', props.ruleForm)
      resetForm(formEl)
    } else {
      console.log('error submit!', fields)
    }
  })
}

const OpenDraw = () => {
  DrawerVisible.value = true
  // ruleFormRef.value?.resetFields()
}

const resetForm = (formEl: FormInstance | undefined) => {
  formEl && formEl.resetFields()
  DrawerVisible.value = false
}



onMounted(() => {
})

defineExpose({
  OpenDraw,
})
</script>

<style lang="scss" scoped>
:deep(.el-form-item__label) {
  color: #000000;
}

.title {
  color: #5087FF;
}
</style>